import API from "Config/API";

// Every call the delivery-partner console makes, in one place.
//
// Paths only — Config/API owns the host and attaches the admin identity
// headers the backend writes onto audit rows.
const base = (id) => `/admin/delivery/${encodeURIComponent(id)}`;

// Strip empty values so `?status=` never reaches the server as a filter for
// the empty string, which would match nothing rather than everything.
const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.append(key, value);
    }
  });
  const str = search.toString();
  return str ? `?${str}` : "";
};

export const getPartner = (id) => API.get(base(id)).then((r) => r.data);

export const getStats = (id) => API.get(`${base(id)}/stats`).then((r) => r.data);

export const getOrders = (id, params) =>
  API.get(`${base(id)}/orders${qs(params)}`).then((r) => r.data);

export const getOrderFilters = (id) =>
  API.get(`${base(id)}/orders/filters`).then((r) => r.data);

export const updateProfile = (id, body) =>
  API.patch(`${base(id)}/profile`, body).then((r) => r.data);

export const getBank = (id, { reveal = false, reason } = {}) =>
  API.get(`${base(id)}/bank${qs({ reveal: reveal || undefined, reason })}`).then(
    (r) => r.data
  );

export const updateBank = (id, body) =>
  API.put(`${base(id)}/bank`, body).then((r) => r.data);

export const setVerification = (id, verified, reason) =>
  API.patch(`${base(id)}/verification`, { verified, reason }).then((r) => r.data);

export const setTakingOrders = (id, isTakingOrders, reason) =>
  API.patch(`${base(id)}/taking-orders`, { isTakingOrders, reason }).then(
    (r) => r.data
  );

export const forceOffline = (id, reason) =>
  API.post(`${base(id)}/force-offline`, { reason }).then((r) => r.data);

export const getDocuments = (id) =>
  API.get(`${base(id)}/documents`).then((r) => r.data);

export const getLocation = (id, params) =>
  API.get(`${base(id)}/location${qs(params)}`).then((r) => r.data);

export const getWallet = (id) => API.get(`${base(id)}/wallet`).then((r) => r.data);

export const getActivity = (id, params) =>
  API.get(`${base(id)}/activity${qs(params)}`).then((r) => r.data);

export const deletePartner = (id, reason, force) =>
  API.post(`${base(id)}/delete`, { reason, force }).then((r) => r.data);
